var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tab-body",
      class: { active: _vm.active, fixed: _vm.fixed },
      attrs: {
        role: "tabpanel",
        "aria-labelledby": "trigger-" + _vm.name,
        tabindex: "0",
        "aria-hidden": !_vm.active
      }
    },
    [
      _c(
        "div",
        { staticClass: "tab-content", style: _vm.bodyStyle },
        [_vm._t("default", null, { tabindex: "0" })],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }